<form [formGroup]="advancedSearchForm">
  <sh-pane
    slot="left"
    label="{{ 'label.advancedSearch' | translate }}"
    behavior="collapse"
    class="advanced-search-filter"
  >
    <sh-icon
      icon="information"
      [attr.aria-label]="'information icon for advanced search'"
      id="advanced-search-icon-info"
      size="s"
      slot="functions"
    ></sh-icon>

    <sh-tooltip
      innerHTML="{{ 'label.advancedSearchInfoIcon.tooltip' | translate }}"
      target="advanced-search-icon-info"
      placement="top"
      variation="long"
      class="info-advances-search-message"
    ></sh-tooltip>

    <sh-icon
      slot="functions"
      icon="reset"
      [attr.aria-label]="'reset advanced search filter'"
      size="s"
      button
      (click)="resetFilter()"
    ></sh-icon>

    <sh-input-text
      label="{{ 'label.serialNumber' | translate }} {{
        'label.startingWith' | translate
      }}"
      [attr.aria-label]="
        ('label.serialNumber' | translate) +
        ' ' +
        ('label.startingWith' | translate)
      "
      formControlName="serialNumber"
      ngDefaultControl
      (clear-clicked)="clearInputValue('serialNumber')"
    >
      <sh-icon
        icon="search"
        slot="icon"
        size="s"
        aria-disabled="true"
      ></sh-icon>
    </sh-input-text>

    <!-- Material Number -->
    <sh-input-number
      label="{{ 'label.systemMaterialNumber' | translate }} {{
        'label.exactMatch' | translate
      }}"
      [attr.aria-label]="
        ('label.systemMaterialNumber' | translate) +
        ' ' +
        ('label.exactMatch' | translate)
      "
      no-arrows
      ngDefaultControl
      formControlName="materialNumber"
      (clear-clicked)="clearInputValue('materialNumber')"
    >
      <sh-icon icon="search" slot="icon" size="s" aria-hidden="true"></sh-icon>
    </sh-input-number>

    <!-- Customer Name -->
    <sh-input-text
      label="{{ 'label.customerName' | translate }} {{
        'label.containing' | translate
      }}"
      [attr.aria-label]="
        ('label.customerName' | translate) +
        ' ' +
        ('label.containing' | translate)
      "
      ngDefaultControl
      formControlName="customerName"
      (clear-clicked)="clearInputValue('customerName')"
    >
      <sh-icon icon="search" slot="icon" size="s" aria-hidden="true"></sh-icon
    ></sh-input-text>

    <!-- Country -->
    <sh-dropdown
      label="{{ 'label.country' | translate }}"
      [attr.aria-label]="'label.country' | translate"
      role="listbox"
      [class.dropdown-with-tags]="selectedCountries.size > 0"
      editable
    >
      <sh-menu-item
        *ngFor="let country of advancedSearchService.countryList$ | async"
        aria-list="list"
        label="{{ country.countryName }} ({{ country.countryId }})"
        [attr.disabled]="selectedCountries.has(country) ? true : null"
        (clicked)="selectCountry(country)"
      ></sh-menu-item>
    </sh-dropdown>

    <div class="tag-block" *ngIf="selectedCountries.size > 0">
      <ng-container *ngFor="let item of selectedCountries; let i = index">
        <sh-tag
          class="tag-item"
          id="{{ i + '_country' }}"
          label="{{ item.countryName }} ({{ item.countryId }})"
          removable
          (closed)="unselectCountry(item)"
        ></sh-tag>
      </ng-container>
    </div>

    <!-- City -->
    <sh-dropdown
      label="{{ 'label.city' | translate }}"
      [attr.aria-label]="'label.city' | translate"
      role="listbox"
      editable
      [class.dropdown-with-tags]="selectedCities.size > 0"
      [attr.disabled]="
        selectedCountries.size === 0 &&
        (advancedSearchService.isCityLoading$ | async) === false
          ? true
          : null
      "
    >
      <ng-container
        *ngIf="advancedSearchService.isCityLoading$ | async; else cityList"
      >
        <div class="spinner-padding">
          <sh-spinner label="Loading Cities..." size="s"></sh-spinner>
        </div>
      </ng-container>

      <ng-template #cityList>
        <sh-menu-item
          *ngFor="let city of advancedSearchService.cityList$ | async"
          label="{{ city.city }}"
          [attr.disabled]="isCitySelected(city) ? true : null"
          (clicked)="selectCity(city)"
        ></sh-menu-item>
      </ng-template>
    </sh-dropdown>

    <div class="tag-block" *ngIf="selectedCities.size > 0">
      <ng-container *ngFor="let item of selectedCities; let i = index">
        <sh-tag
          class="tag-item"
          id="{{ i + '_city' }}"
          label="{{ item.city }}"
          removable
          (closed)="unselectCity(item)"
        ></sh-tag>
      </ng-container>
    </div>

    <!-- Functional Location -->
    <sh-input-text
      label="{{ 'label.functionalLocation' | translate }} {{
        'label.containing' | translate
      }}"
      [attr.aria-label]="
        ('label.functionalLocation' | translate) +
        ' ' +
        ('label.containing' | translate)
      "
      ngDefaultControl
      formControlName="functionalLocation"
      (clear-clicked)="clearInputValue('functionalLocation')"
      ><sh-icon icon="search" slot="icon" size="s" aria-hidden="true"></sh-icon
    ></sh-input-text>

    <!-- Modality -->
    <sh-dropdown
      label="{{ 'label.input.modalityId' | translate }}"
      [attr.aria-label]="'label.input.modalityId' | translate"
      role="listbox"
      multi-select
    >
      <sh-menu-item
        *ngFor="let modality of modalities | async"
        aria-list="list"
        label="{{ modality.displayName }}"
        [active]="activeModalities.includes(modality.displayName)"
        (clicked)="onModalityChanged(modality.displayName)"
      ></sh-menu-item>
    </sh-dropdown>

    <!-- Product Name -->
    <sh-dropdown
      label="{{ 'label.productName' | translate }}"
      [attr.aria-label]="'label.productName' | translate"
      role="listbox"
      editable
      [class.dropdown-with-tags]="selectedProducts.size > 0"
      [attr.disabled]="activeModalities.length > 0 ? null : true"
    >
      <sh-menu-item
        *ngFor="let product of advancedSearchService.productNameList$ | async"
        aria-list="list"
        label="{{ product.marketingProductName }}"
        [attr.disabled]="isProductSelected(product) ? true : null"
        (clicked)="selectProduct(product)"
      ></sh-menu-item>
    </sh-dropdown>

    <div class="tag-block" *ngIf="selectedProducts.size > 0">
      <ng-container *ngFor="let item of selectedProducts; let i = index">
        <sh-tag
          class="tag-item"
          id="{{ i + '_product' }}"
          label="{{ item.marketingProductName }}"
          removable
          (closed)="unselectProduct(item)"
        ></sh-tag>
      </ng-container>
    </div>

    <!-- Software Version-->
    <sh-dropdown
      label="{{ 'label.softwareVersion' | translate }}"
      [attr.aria-label]="'label.softwareVersion' | translate"
      role="listbox"
      editable
      [class.dropdown-with-tags]="selectedSoftwares.size > 0"
      [attr.disabled]="selectedProducts.size > 0 ? null : true"
    >
      <sh-menu-item
        *ngFor="
          let software of advancedSearchService.softwareVersionList$ | async
        "
        aria-list="list"
        label="{{ software.swMainVersion }}"
        [attr.disabled]="isSoftwareSelected(software) ? true : null"
        (clicked)="selectSoftware(software)"
      ></sh-menu-item>
    </sh-dropdown>

    <div class="tag-block" *ngIf="selectedSoftwares.size > 0">
      <ng-container *ngFor="let item of selectedSoftwares; let i = index">
        <sh-tag
          class="tag-item"
          id="{{ i + '_software' }}"
          label="{{ item.swMainVersion }}"
          removable
          (closed)="unselectSoftware(item)"
        ></sh-tag>
      </ng-container>
    </div>

    <!-- Equipment Id -->
    <sh-input-text
      label="{{ 'label.equipmentId' | translate }} {{
        'label.startingWith' | translate
      }}"
      [attr.aria-label]="
        ('label.equipmentId' | translate) +
        ' ' +
        ('label.startingWith' | translate)
      "
      ngDefaultControl
      formControlName="equipmentId"
      (clear-clicked)="clearInputValue('equipmentId')"
      ><sh-icon icon="search" slot="icon" size="s" aria-hidden="true"></sh-icon
    ></sh-input-text>

    <!-- Equipment Tech Id-->
    <sh-input-text
      label="{{ 'label.equipmentTechId' | translate }} {{
        'label.startingWith' | translate
      }}"
      [attr.aria-label]="
        ('label.equipmentTechId' | translate) +
        ' ' +
        ('label.startingWith' | translate)
      "
      ngDefaultControl
      formControlName="equipmentTechId"
      (clear-clicked)="clearInputValue('equipmentTechId')"
      ><sh-icon icon="search" slot="icon" size="s" aria-hidden="true"></sh-icon
    ></sh-input-text>

    <!-- Equipment Status -->
    <sh-dropdown
      id="equipment-status-dropdown"
      label="{{ 'label.input.equipmentStatus' | translate }}"
      [attr.aria-label]="'label.input.equipmentStatus' | translate"
      role="listbox"
    >
      <sh-menu-item
        *ngFor="let option of equipmentStatus"
        aria-list="list"
        label="{{ option }}"
        [active]="'Active' === option"
        (clicked)="selectEquipmentStatus(option)"
      ></sh-menu-item>
    </sh-dropdown>

    <!-- Support Status-->
    <sh-dropdown
      id="support-status-dropdown"
      label="{{ 'label.input.supportStatus' | translate }}"
      [attr.aria-label]="'label.input.supportStatus' | translate"
      role="listbox"
    >
      <sh-menu-item
        *ngFor="let supportOption of supportStatus"
        aria-list="list"
        label="{{ supportOption }}"
        [active]="'Supported' === supportOption"
        (clicked)="selectSupportStatus(supportOption)"
      ></sh-menu-item>
    </sh-dropdown>

    <sh-button
      slot="footer"
      color="primary"
      label="Search systems"
      size="auto"
      (click)="onSubmit()"
    ></sh-button>
  </sh-pane>
</form>
